import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Layout from 'components/Layout';
import hasAuthToken from 'lib/hasAuthToken';
import Link from 'next/link';

const ReferencesPage = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t('references.pageTitle')}>
      <div className="o-retain o-retain--lap u-margin-top-huge u-margin-bottom-huge">
        <h1>{t('references.pageHeading')}</h1>
        <h2>Your Accountants &amp; Adviseurs</h2>
        <p>
          Dit was de eerste keer dat wij een functie via deBanenSite.nl hebben
          geplaatst. En dat hebben we geweten ook; nog niet eerder zoveel
          sollicitaties mét passende CV's mogen ontvangen!
          <br />
          Daarnaast een snelle en goede service met een vaste contactpersoon.
          Wanneer we weer een functie vacant hebben weten wij wie we moeten
          bellen!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/your-accountants-adviseurs-b-v"
            title="Vacatures Your Accountants &amp; Adviseurs"
          >
            Bekijk alle Your Accountants &amp; Adviseurs vacatures
          </Link>
        </p>
        <h2>Haagse Wijk- en Woonzorg (HWW zorg)</h2>
        <p>
          Prettig en persoonlijk contact, denken graag mee en altijd snel actie.
          Ook in een zeer lastig arbeidsmarkt leveren de vacatures op de
          banensite toch regelmatig tot goede reacties. Buitengewoon tevreden
          over onze samenwerking.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link href="/vacatures/hww-zorg" title="Vacatures HWW Zorg">
            Bekijk alle HWW Zorg vacatures
          </Link>
        </p>
        <h2>NHL Stenden Hogeschool</h2>
        <p>
          Vacatures plaatsen via deBanenSite voldoet mij heel goed. Ik ontvang
          altijd bericht als de vacature op de site staat. Hoeveel mensen naar
          de vacature hebben gekeken en wanneer de vacature van de site wordt
          gehaald. Ik krijg ook meer reacties op de vacatures die via
          deBanenSite zijn geplaatst. Verder wordt er altijd met mij meegedacht,
          bijvoorbeeld bij een moeilijk vervulbare vacature. De samenwerking is
          zo fijn, de organisatie heel efficiënt en plezierig. Het voelt alsof
          ik altijd met een collega bel. In plaats van met een extern bedrijf.
          Daarom wil ik jullie allen hartelijk bedanken voor al het werk dat na
          een opdracht van mij wordt uitgevoerd. Top.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link href="/vacatures/nhl-stenden" title="Vacatures NHL Stenden">
            Bekijk alle NHL Stenden vacatures
          </Link>
        </p>
        <h2>V-Fiets</h2>
        <p>
          <span>
            Voor mij was het contact met de mensen van deBanenSite een
            verademing. Wat mij als eerste opviel was het persoonlijke contact.
            Meedenken, niet opdringerig. Heel fijn.
            <br />
          </span>
          <span>
            Toen we tot een overeenkomst kwamen hebben ze mij ook geholpen om de
            vacaturetekst hier en daar nog wat aan te scherpen, zodat ik de
            meeste kans had om DE kandidaat te vinden. En voor dat ik het wist
            stond alles online. Ik hoefde niets te doen. Naderhand kreeg ik de
            factuur, niets vooraf betalen.
            <br />
          </span>
          We kregen al vrij snel vele reacties binnen en na een aantal
          gesprekken hebben we een nieuwe collega gevonden. Tijdens dit hele
          proces ben ik ook nog door de mensen van deBanenSite benaderd om te
          vragen of alles naar wens verliep. Of dat er nog vragen waren.
          <br />
          <span>
            Ik kan niet anders zeggen dat deze samenwerking mij heel goed
            bevallen is. Als we weer een vacature hebben dan zal ik direct
            contact opnemen met jullie!
            <br />
          </span>
          <span>Bedankt!</span>
        </p>
        <p>
          <span>
            <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
            &nbsp;-&nbsp;
            <Link href="/vacatures/v-fiets-b-v" title="Vacatures V-Fiets">
              Bekijk alle V-Fiets vacatures
            </Link>
          </span>
        </p>
        <h2>Nederlandse vereniging van pedagogen en onderwijskundigen (NVO)</h2>
        <p>
          <span>
            Het is nu voor de vierde keer dat wij onze vacatures via
            deBanensite.nl laten lopen. De vacatures worden snel geplaatst. Wij
            vinden het fijn als er een voorselectie gebeurt en dat doet
            deBanenSite.nl altijd voor ons. Zo wordt het kaf van het koren
            gescheiden en kunnen wij onze aandacht geheel richten op de
            kandidaten die daadwerkelijk een match met onze organisatie en
            functies vertonen. Fijn vind ik ook de site waarop je precies kunt
            volgen dat je vacature online staat en hoe vaak er naar gekeken
            wordt. Dat geeft informatie over of je vacature er wel voldoende
            uitspringt. Het contact met deBanenSite.nl is adequaat en
            persoonlijk. Heel efficiënt om zo’n hulp bij de selectie te hebben!
          </span>
        </p>
        <p>
          <span>
            <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
            &nbsp;-&nbsp;
            <Link
              href="/vacatures/nvo-nederland"
              title="Vacatures NVO Nederland"
            >
              Bekijk alle NVO Nederland vacatures
            </Link>
          </span>
        </p>
        <h2>
          <span>Sanitairkamer</span>
        </h2>
        <p>
          deBanensite.nl heeft ons inmiddels meerdere keren geholpen met het
          vinden van geschikte kandidaten voor onze vacatures.
        </p>
        <p>
          <span>
            Het contact met onze contactpersoon van deBanensite.nl is heel
            prettig, en er wordt snel geschakeld om een vacature zo snel
            mogelijk in te vullen.
            <br />
          </span>
          <span>
            Wij hebben inmiddels chauffeurs, commercieel medewerkers en
            logistiek medewerkers in dienst met dank aan deBanensite.nl
            <br />
          </span>
          <span>
            Kortom deBanensite.nl is voor ons de beste partner bij de zoektocht
            naar personeel!
          </span>
        </p>
        <p>
          <span>
            <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
            &nbsp;-&nbsp;
            <Link
              href="/vacatures/sanitairkamer-b-v"
              title="Vacatures Sanitairkamer"
            >
              Bekijk alle Sanitairkamer vacatures
            </Link>
          </span>
        </p>
        <h2>Family IJburg</h2>
        <p>
          Super snelle service, binnen één dag stond de vacature online en al
          snel stroomde de inbox vol! Nogmaals dank voor het snelle handelen en
          zeker tot in de toekomst.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/family-ijburg-b-v"
            title="Vacatures Family IJburg"
          >
            Bekijk alle Family IJburg vacatures
          </Link>
        </p>
        <h2>Stichting Zorgcentrum het Bildt</h2>
        <p>
          Zeer snelle en goede service en een prettig contact met de
          contactpersoon van de Banensite. Je krijgt mooie aanbiedingen om
          vacatures te plaatsen en je hebt er zelf geen werk van. Omdat wij als
          kleine, zelfstandige zorgorganisatie goed aan personeel kunnen komen
          maken wij zelden gebruik van externe vacaturesites. Ivm het tijdelijk
          moeilijk kunnen invullen van bepaalde functies binnen de zorg hebben
          wij, als organisatie, er toch voor gekozen om kennis te maken met de
          Banensite. Via hun hebben we twee vacatures uitgezet. We hebben hier
          een aantal reacties op gekregen en de vacatures in korte tijd toch nog
          kunnen invullen. Een echte aanrader!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/stichting-zorgcentrum-het-bildt/"
            title="Vacatures Stichting Zorgcentrum het Bildt"
          >
            Bekijk alle Stichting Zorgcentrum het Bildt vacatures
          </Link>
          <br />
          <br />
        </p>
        <h2>Schoonderwoerd Vlees BV</h2>
        <p>
          deBanenSite.nl, heeft ons meerdere malen aan de juiste kandidaat
          geholpen in verschillende functies.
          <br />
          Zowel in de functie als Chauffeur, Expeditie medewerker en een
          combinaties van deze functie. Maar ook hebben wij via deBanenSite.nl
          een geschikte kandidaat kunnen invullen in de functie financieel
          controller.
          <br />
          Door het breed uitzetten van de vacature op verschillende platformen
          zijn wij zeer tevreden over kwaliteit van de reacties maar vooral ook
          de accuraat van deBanenSite.nl zelf.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/schoonderwoerd-vlees-b-v/"
            title="Vacatures Schoonderwoerd Vlees BV"
          >
            Bekijk alle Schoonderwoerd Vlees BV vacatures
          </Link>
        </p>
        <h2>Buurman &amp; Buurman</h2>
        <p>
          Onze werving via deBanensSite.nl verloopt voorspoedig.
          <br />
          Snelle plaatsing, servicegerichtheid en het persoonlijk contact
          ervaren wij als prettig.
          <br />
          Daarnaast werkt het sollicitatie beheersysteem tijd besparend en is
          overzichtelijk.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/buurman-buurman/36016/"
            title="Vacatures Buurman en buurman"
          >
            Bekijk alle Buurman &amp; Buurman vacatures
          </Link>
        </p>
        <h2>To The Max Callcenter</h2>
        <p>
          In een callcenter is een hoog verloop onder het personeel zeer
          gebruikelijk. Het is dan ook van cruciaal belang om een constante
          toestroom aan personeel te behouden. Om dit te regelen maken wij
          gebruik van de diensten van verschillende vacaturesites. Het is ons in
          positieve zin opgevallen dat het aantal mensen dat langer dan 1 maand
          werkte bij de banensite vele malen groter was dan dat van alle andere
          partijen waar wij onze werving onder gebracht hebben.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/to-the-max-callcenter-bv/38161/"
            title="Vacatures to the max callcenter"
          >
            Bekijk alle vacatures van To The Max Callcenter
          </Link>
        </p>
        <h2>TSA Safety Group B.V. te Goes.</h2>
        <p>
          We zijn zeer te spreken over de snelle plaatsing van onze vacatures en
          de servicegerichtheid van deBanenSite.nl.
        </p>
        <p>
          Het meedenken met de invulling van de vacatures hebben we als zeer
          prettig ervaren.
        </p>
        <p>
          Onze vacatures hebben we in samenwerking met deBanenSite.nl zeer snel
          kunnen vervullen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/tsa-safety-services/37560/"
            title="Vacatures TSA Safety group"
          >
            Bekijk alle vacatures van TSA Safety Group
          </Link>
        </p>
        <h2>Stichting Openbaar Voortgezet Onderwijs Gouda</h2>
        <p>
          Na plaatsing op deBanenSite.nl hebben we beide vacatures kunnen
          vervullen. Eenvoudig, lage kosten en prima resultaat.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/stichting-openbaar-voortgezet-onderwijs-gouda/36946/"
            title="Vacatures Stichting Openbaar Voortgezet Onderwijs Gouda"
          >
            Bekijk alle vacatures van Stichting Openbaar Voortgezet Onderwijs
            Gouda
          </Link>
        </p>
        <h2>De Loogman Groep</h2>
        <p>Blij verast door de snelle online stelling van de vacatures.</p>
        <p>
          Tevens positief verrast door de vele, maar ook kwalitatief goede,
          reacties op onze vacatures die wij onlangs op deBanenSite.nl heb
          geplaatst.
          <br />
          Binnen aantal weken 3 van de 3 uitstaande vacatures vervuld. Top dus!!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href={`/werkgevers/?trefwoord%5B%5D=de+loogman+groep&amp;plaats=&amp;zipcode=&amp;afstand=30&amp;latlng=%2C`}
            title="vacatures de loogman groep"
          >
            Bekijk alle vacatures van De Loogman Groep
          </Link>
        </p>
        <h2>BORGH BV</h2>
        <p>
          Al geruime tijd maken wij gebruik van deBanenSite.nl voor onze
          buitendienst vacatures. Sinds kort kunnen wij zelfs onbeperkt
          vacatures plaatsen.
        </p>
        <p>
          Wij zijn zeer te spreken over deBanenSite.nl! Uitstekende service,
          leuk contact en wat wij belangrijk vinden; er wordt met je mee
          gedacht.
        </p>
        <p>
          Diverse rayons hebben wij reeds in kunnen vullen en wij gaan er van
          uit dat dit er alleen maar meer zullen gaan worden.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link href="/vacatures/borgh-bv/5655/" title="vacatures Borgh">
            Bekijk alle vacatures van Borgh
          </Link>
        </p>
        <h2>NederWoon Verhuurmakelaars</h2>
        <p>
          Onze Commerciële vacature is succesvol vervuld. deBanenSite.nl denkt
          mee en is erg servicegericht. De volgende vacature plaats ik zeker
          weer op deBanenSite.nl.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/nederwoon-verhuurmakelaars-amersfoort/36592/"
            title="Vacatures Nederwoon verhuurmakelaars"
          >
            Bekijk alle vacatures van NederWoon Verhuumakelaars
          </Link>
        </p>
        <h2>Comtech Telecom BV</h2>
        <p>
          Wij hebben wederom onze vacature succesvol ingevuld via
          deBanenSite.nl.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/comtech-telecom/3205/"
            title="Vacatures Comtech"
          >
            Bekijk alle vacatures van Comtech Telecom
          </Link>
        </p>
        <h2>TruckWash Utrecht</h2>
        <p>
          We hebben inmiddels twee nieuwe medewerkers aangenomen via
          deBanenSite.nl, dus het doel is bereikt.
          <br />
          Bedankt hiervoor!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/truckwash-utrecht/36558/"
            title="Vacatures TruckWash"
          >
            Bekijk alle vacatures van TruckWash Utrecht
          </Link>
        </p>
        <h2>SG de Overlaat</h2>
        <p>
          Op de vacature voor docent Mobiliteit en Transport hebben wij 1
          reactie ontvangen.
          <br />
          De campagnemanager van deBanenSite.nl&nbsp;stelde voor om deze
          vacature ook uit te zetten in de “oude” benaming, n.l. docent
          Voertuigentechniek.
          <br />
          Ook op deze vacature hebben we&nbsp;reactie gehad, maar wel een hele
          goede. Een bevoegd docent, met heel veel praktijkervaring.
        </p>
        <p>
          Wij hebben de man ondertussen aangenomen. Dus……deBanenSite.nl was weer
          succesvol!!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/sg-de-overlaat/34477/"
            title="Vacatures SG de Overlaat"
          >
            Bekijk vacatures van SG de Overlaat
          </Link>
        </p>
        <h2>Meester Vos</h2>
        <p>
          Meester Vos biedt al meer dan 10 jaar fiscale en administratieve
          ondersteuning voor particulieren, ondernemers, DGA’s, pensioen- en
          stamrecht B.V.’s. Vanwege onze no-nonsense aanpak is de organisatatie
          in minder dan 5 jaar meer dan verdubbeld.
        </p>
        <p>
          Via deBanenSite.nlhebben we meermalen de juiste professionals gevonden
          voor onze vacatures op verschillende vakgebieden en verschillend
          niveau. deBanenSite.nl biedt daarbij niet alleen een digitaal platform
          maar ook persoonlijke ondersteuning om de vacature op de juiste manier
          onder de aandacht van de geschikte kandidaten te brengen. We zijn
          daarbij door de medewerkers van deBanenSite echt ontzorgd. deBanenSite
          is dan ook een vaste partner van Meester Vos geworden voor de
          invulling van onze vacatures.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/meester-vos-belastingadviseurs/35816/"
            title="Vacatures Meester Vos"
          >
            Bekijk alle vacatures van Meester Vos
          </Link>
        </p>
        <h2>Alutech Nederland BV</h2>
        <p>
          Verheugd kan ik meedelen dat wij de vacature Key Accountmanager hebben
          voorzien middels een kandidaat die heeft gereageerd via
          deBanenSite.nl.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/alutech-nederland-bv/3767/"
            title="Vacatures Alutech"
          >
            Bekijk alle vacatures van Alutech Nederland
          </Link>
        </p>
        <h2>Adviesbureau E.C.O. Logisch</h2>
        <p>
          Succesvol ingevuld! Indien we weer een vacature krijgen, zal ik na het
          succes van de vorige keer zeker weer bij jullie aankloppen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/adviesbureau-e-c-o-logisch/34475/"
            title="Vacatures Adviesbureau E.C.O. Logisch"
          >
            Bekijk alle vacatures van Adviesbureau E.C.O. Logisch
          </Link>
        </p>
        <h2>Hubrecht Institute&nbsp;</h2>
        <p>
          Onlangs hebben wij een vacature voor dierverzorger uitgezet via
          deBanenSite.nl. Binnen enkele weken hebben wij de geschikte kandidaat
          gevonden en danken deBanenSite.nl voor een goede en efficiënte
          samenwerking.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href="/vacatures/hubrecht-institute/4487/"
            title="Vacatures Hubrecht Institute"
          >
            Bekijk alle vacatures van Hubrecht Institute
          </Link>
        </p>
        <h2>Kraamcentrum</h2>
        <p>
          Wij zijn heel blij dat we via jullie een leuke collega erbij mochten
          krijgen, zodat ons team in de kraamzorg voldoende kraamgezinnen mogen
          helpen in een hele bijzondere periode “de kraamweek”.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
          <Link
            href={`/vacatures/kraamcentrum/35642/"`}
            title="Vacatures Kraamcentrum"
          >
            Bekijk alle vacatures van Kraamcentrum
          </Link>
        </p>
        <h2>Zonneveld Trucks</h2>
        <p>
          Zonneveld Trucks is al meer dan 30 jaar actief en Beverwijk en
          omstreken. Samen met Zonneveld Carrosserie vormen wij een full-service
          partner voor de transportsector en bestelwagenbranche. Met onze goed
          opgeleide professionals streven wij naar een zo hoog mogelijke
          klanttevredenheid in de bedrijfswagenwereld. Dit doen wij dan ook met
          onze kwalitatief hoogwaardige service en diensten.
        </p>
        <p>
          Voor de invulling van een vacature hebben wij gebruik gemaakt van de
          diensten van deBanenSite.nl. Mede door het brede bereik van
          deBanenSite.nl en de goede service van de medewerkers hebben wij een
          bekwame&nbsp;Bedrijfswagen Monteur&nbsp;gevonden en aangenomen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Company Webcast</h2>
        <p>
          'Met dank aan deBanenSite.nl hebben wij een voor ons moeilijk in te
          vullen vacature, toch weten in te vullen. Hier zijn wij zeer verheugd
          over aangezien we voorheen veelal een werving &amp; selectie bureau
          nodig hadden hiervoor. De vacature waar het om ging is die van Webcast
          technicus. Een Webcast technicus is een persoon die op locatie alle
          techniek rondom de webcast verzorgt. Er zijn maar zeer weinig
          bedrijven die dit soort functies aanbieden en voor een mogelijke
          geschikte kandidaat is het veelal onbekend terrein. Het team van
          Webcast technici bestaat nu uit vier personen en op basis van onze
          verwachte groei zie ik uitbreiding voor de toekomst. Op deBanenSite.nl
          ga ik dan zeker weer deze vacature plaatsen. Ook voor andere vacatures
          zie ik deBanenSite.nl als een betrouwbare partner om deze voor ons
          succesvol in te vullen'
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Innoforte</h2>
        <p>
          Innoforte is een serviceorganisatie voor overwegend ouderen. Service
          op het gebied van wonen, zorg en ontspanning. Onze filosofie is dat
          ouderen zelf de regie over hun eigen leven voeren. Wie niet meer
          zelfstandig kan wonen, vindt bij ons een prettig plekje op één van
          onze mooie locaties. De ander heeft thuiszorg nodig of maakt alleen
          gebruik van personenalarmering. De volgende verzorgt zelf haar
          dementerende partner, maar heeft ook behoefte aan tijd voor zichzelf.
          Zo heeft iedere oudere zijn eigen wensen voor zijn eigen dagelijks
          leven. Wij geven de service die dat mogelijk maakt. Wij staan voor
          vertrouwde zorg, deskundigheid, aandacht en nabijheid. Een (w)aardige
          oude dag is daarbij ons devies.
        </p>
        <p>
          Voor de invulling van onze vacatures plaatsen wij met regelmaat
          vacatures op deBanenSite.nl. Dit tot volle tevredenheid. We merken dat
          de vacaturesite goed geraadpleegd wordt en ontvangen altijd veel en
          over het algemeen kwalitatief goede c.v.'s van kandidaten.
        </p>
        <p>
          Wij zijn zeer tevreden over de dienstverlening en klantvriendelijkheid
          van de medewerkers van deze site.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Ophtec</h2>
        <p>
          Voor het eerst via deBanenSite.nl geworven.
          <br />
          Prima respons en dé kandidaat zat er ook tussen.
          <br />
          Kortom een tevreden klant!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>BP Europa S.E. – BP Nederland / Actomat B.V.</h2>
        <p>
          Via deBanenSite.nl hebben we vrijwel al onze moeilijk vervulbare
          vacatures op onze service stations kunnen invullen. Met het juiste
          functieprofiel en een passende beschrijving op de website konden we al
          snel gebruik maken van de diensten van deBanenSite.nl.
          <br />
          De medewerkers van deBanenSite.nl denken mee en bieden goede service.
          De samenwerking was goed, mede daardoor zullen we bij een volgende
          vacature zeker weer gebruik maken van deBanenSite.nl. Kortom; een
          aanrader!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Tejo Vleesprodukten</h2>
        <p>
          Worstmaker,
          <br />
          Na een lang traject van adverteren in kranten en op diverse sites nu
          dan eindelijk via deBanenSite.nl een geschikte kandidaat gevonden.
          &nbsp;
          <br />
          In de toekomst zullen wij zeker weer gebruik maken van de diensten van
          deBanenSite.nl
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Lancker Wolters</h2>
        <p>
          Een advertentie voor beveiligingsmonteur heeft voor ons zeer positief
          uitgepakt.
          <br />
          Tegen alle verwachtingen in heeft het ons maar liefst twee nieuwe
          personeelsleden opgeleverd!
          <br />
          De volgende keer dat we op zoek zijn naar nieuw personeel, zullen we
          dit zeker weer via&nbsp;deBanenSite.nl doen!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>International Security Agency</h2>
        <p>
          Na het plaatsen van een advertentie op deBanenSite.nl volgden veel
          reacties. Onze nieuwe collega is afgelopen week succesvol begonnen met
          zijn nieuwe baan.
        </p>
        <p>Het meedenken en de snelle service is door ons op prijs gesteld.</p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Administratiekantoor G. Verseput</h2>
        <p>
          deBanenSite.nl is voor ons een prima middel om doelgericht een
          geschikte kandidaat te vinden voor ons kantoor. Als je zorgt voor een
          juist profiel, dan kun je via de digitale weg, snel en makkelijk de
          juiste kandidaat vinden.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>De Hobbyist BV</h2>
        <p>
          Voor onze Franstalige klanten zochten wij een collega die vloeiend
          Frans spreekt. Via deBanenSite.nl een Française gevonden die al jaren
          in Nederland woont en ook nog eens uitstekend Nederlands spreekt.
        </p>
        <p>
          <strong>Wij zijn super tevreden!</strong>
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Limagrain Nederland BV&nbsp;</h2>
        <p>
          Wij zijn erg tevreden over de dienstverlening van deBanenSite.nl, we
          hebben deze moeilijke vacature succesvol kunnen invullen. Vooral het
          meedenken over de vacaturetekst vond ik van toegevoegde waarde.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Technisch Bureau Lindhout</h2>
        <p>
          Wij hadden eerst onze vacature op een aantal grote banensites
          geplaatst. Wel redelijk wat reacties met weinig mensen met de
          kwalificaties die we zochten. Via deBanenSite.nl hadden we binnen
          enkele dagen reacties van goede kandidaten.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Zone 3</h2>
        <p>
          Wij zijn zeer tevreden over de dienstverlening van deBanenSite.nl.
        </p>
        <p>
          Zone3 heeft regelmatig vacatures op verschillende niveaus, van
          uitvoerende functies tot tactische functies op HBO niveau. Dankzij
          publicatie op deBanenSite.nl ontvangen wij veel passende reacties en
          hebben op die manier al regelmatig een vacature succesvol in kunnen
          vullen. Wij hebben daarnaast ervaring met de voorselectie door
          deBanenSite.nl, wat ook heel goed gewerkt heeft voor bepaalde
          vacatures. Na voorselectie komen alleen de meest relevante
          sollicitaties binnen wat ons zeer veel tijd heeft bespaard. Deze
          service is bovendien erg voordelig.
        </p>
        <p>
          Ook een compliment voor de medewerkers van deBanenSite.nl: zij
          reageren snel en denken met je mee, hierdoor worden de resultaten van
          de werving geoptimaliseerd.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Zorgkamer Bentelerhof</h2>
        <p>
          We hebben de vacature Verzorgende succesvol ingevuld.
          <br />
          Enorm veel goede reacties gehad, dus ik ben helemaal blij!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Telecombinatie Coen's Trading</h2>
        <p dir="ltr">
          We hebben al enige tijd onze nieuwe collega in dienst voor de afdeling
          boekhouding. We hebben tot op heden een goede indruk van hem. <br />
          We zijn zeer tevreden over hem.
        </p>
        <p dir="ltr">
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Security Professionals B.V.</h2>
        <p>Uw veiligheid is ons beleid!</p>
        <p>
          Security Professionals B.V. is een beveiligingsorganisatie die alle
          voorkomende beveiligingswerkzaamheden uitvoerd door heel Nederland.
          Wij zijn continu op zoek naar nieuwe medewerkers die reeds werkzaam
          zijn (geweest) in de beveiliging, maar ook nieuwe medewerkers die
          willen gaan starten in de beveiliging. Wij zorgen voor de
          noodzakelijke begeleiding en aanvullende trainingen / opleidingen
          waardoor men op een professionele manier kan worden ingezet als
          beveiligingsmedewerker.
        </p>
        <p>
          Na het online zetten van ons bedrijfsprofiel door deBanenSite.nl
          hebben wij een overweldigend aantal reacties mogen ontvangen.
          Binnenkort heten wij onze nieuwe collega’s welkom binnen onze
          organisatie.
        </p>
        <p>Chapeau voor de manier waarop deBanenSite.nl te werk gaat!</p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>MCD Supermarkten</h2>
        <p>
          Onze eerste ervaring met “deBanenSite.nl” is ontzettend positief
          uitgepakt.
        </p>
        <p>Wij hebben onze vacatures kwalitatief goed in weten te vullen!</p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Detail Management Groep</h2>
        <p>
          DMG is de franchisegever van zo’n 200 Deco Home en Verf &amp; Wand
          winkels. Omdat online activiteiten niet meer weg te denk zijn en
          steeds meer tijd kosten wilde we het team uitbreiden en hadden we een
          vacature beschikbaar voor de functie Coördinator Web Content en
          Design. We hebben hiervoor eind december deBanenSite.nl ingeschakeld
          en binnen no-time hadden me meer dan genoeg relevante sollicitaties
          binnen waaruit we konden kiezen. Binnenkort verwelkomen we onze nieuwe
          collega. deBanenSite.nl bedankt!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Art of Cards B.V.</h2>
        <p>
          Binnen enkele uren na de plaatsing van de advertentie begonnen de
          sollicitaties al binnen te stromen, dus de site wordt makkelijk
          gevonden door werkzoekenden. Wij hebben er voldoende geschikte
          kandidaten aan over gehouden. Over de service van de medewerkers van
          deBanenSite.nl zijn we ook erg tevreden, ze denken met je mee en
          reageren snel en adequaat op vragen. Bij eventueel toekomstige
          vacatures zullen wij zeker weer gebruik maken van hun diensten.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>PCH Dienstengroep</h2>
        <p>een VolkerWessels onderneming</p>
        <p>
          Na de vacature voor Medewerker Parkeerservices geplaatst te hebben op
          deBanenSite.nl, volgde er vele reacties. Hieruit hebben wij al snel
          een geschikte kandidaat gevonden. Wij zijn super enthousiast over
          deBanenSite.nl en het is zeker een aanrader voor elk soort
          organisatie!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>CVD (Centrum Voor Dienstverlening te Rotterdam)</h2>
        <p>
          Het CVD (Centrum Voor Dienstverlening te Rotterdam) was op zoek naar
          een medewerker communicatie en voorlichting.
          <br />
          Ik was zeer verrast dat via deBanenSite.nl zo snel reacties zijn
          gekomen op deze vacature. In korte tijd hadden we genoeg sollicitanten
          om binnen 3 weken de juiste persoon binnen te halen.
        </p>
        <p>
          Het principe dat deBanenSite.nl hanteert (zoekmachine optimalisatie)
          werkt !
        </p>
        <p>
          De kosten die wij kwijt waren voor de plaatsing van de vacature zijn
          zeer de moeite waard geweest.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>NuWo v.o.f.</h2>
        <p>
          Nadat NuWo v.o.f. enkele keren benaderd is geweest door de banensite
          om onze vacature te plaatsen was ik hier eerst niet zo van
          gecharmeerd. Toch zijn wij tot een overeenkomst gekomen en ik moet
          eerlijk zeggen dat het mijn verwachting overtrof. NuWo v.o.f heeft
          middels deze manier van adverteren 7 personen uitgezocht waarvan er 5
          zijn aangenomen. Ik wil de medewerkers van deBanenSite.nl dan ook
          namens NuWo v.o.f. hartelijk dank zeggen voor de correcte manier van
          handelen. Mochten wij in de toekomst weer vacatures hebben dan zullen
          wij zeker van uw diensten gebruik maken.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Jaguar, the fresh company B.V.</h2>
        <p>
          Na de vacature voor binnendienst medewerker geplaatst te hebben op
          deBanenSite.nl, volgden vele reacties. Hieruit hebben we een kandidaat
          geselecteerd die ons team komt versterken. Mochten we weer een
          vacature open hebben, zullen we deze zeker weer plaatsen op
          deBanenSite.nl.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Van Kempen Tankstations B.V.</h2>
        <p>
          Na het plaatsen van een advertentie op deBanenSite.nl volgde er al
          snel reacties, wij hebben verschillende kandidaten uitgenodigd voor
          een gesprek en uit deze kandidaten hebben wij een geschikte manager
          gevonden.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Stream</h2>
        <p>
          Wij hebben regelmatig meertalige kandidaten nodig en via
          deBanenSite.nl hebben wij onze vacature binnen een zeer korte periode
          weten in te vullen! deBanenSite.nl, bedankt!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Stichting Katholiek Onderwijs Echt-Maasbracht</h2>
        <p>
          Via deBanenSite.nl hebben wij voor onze Stichting Katholiek Onderwijs
          Echt-Maasbracht e.o. een vacature geplaatst voor een teamleider voor
          een van onze basisscholen. Wij hebben uiteindelijk via deze
          advertentie uit een aantal sollicitaties een goede keuze kunnen maken
          voor onze leerlingen en zijn zeer tevreden over de dienstverlening en
          klantvriendelijkheid van de medewerkers van deze site.
        </p>
        <p>
          Dit was voor ons de eerste keer dat wij van een dergelijk medium
          gebruik hebben gemaakt voor het invullen van een vacature binnen onze
          Stichting. Mocht zich de gelegenheid weer voordoen, dan zullen wij
          zeer zeker niet aarzelen nogmaals gebruik te maken van deze
          mogelijkheid.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Joint Analytical Systems BNL.</h2>
        <p>
          Dankzij deBanenSite.nl zijn wij weer een collega rijker.
          <br />
          We zijn vooral enthousiast over de hulp, die we na plaatsing van de
          vacature, hebben gekregen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Van den Bosch Machinebouw</h2>
        <p>
          Via deBanenSite.nl hebben wij een nieuwe collega CNC draaier gevonden.
          <br />
          Wij vinden deze site dan ook een goede manier om geschikt personeel te
          vinden en zeker een aanrader.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Rosier Nederland B.V.</h2>
        <p>
          Ik ben positief verrast door de vele reacties die ik heb ontvangen op
          de vacature van Procesoperator die op de banensite heb geplaatst.
          <br />
          Niet alleen het aantal was hoger dan verwacht , maar ook de kwaliteit
          van de sollicitanten voldeed ruimschoots aan mijn verwachtingen.
          <br />
          Bij een volgende vacature wil ik zeker weer gebruik maken van
          deBanenSite.nl.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Synaps Adm. dienstverlening en Advisering B.V.</h2>
        <p>
          Voor invulling van de vacature administratief medewerker hebben wij
          voor het eerst gebruik gemaakt van deBanenSite.nl
          <br />
          Uit de ruim 50 reacties welke wij mochten ontvangen is het ons gelukt
          de juiste kandidaat te selecteren.
          <br />
          Mochten wij in de toekomst een vacature hebben, zullen wij deze
          opnieuw proberen in te vullen via deBanenSite.nl
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Izore - Centrum Infectieziekten Friesland</h2>
        <p>
          Via deBanenSite.nl is onze vacature snel uitgezet. Het bereik is
          groot, dat is gebleken uit de bijna 100 reacties die wij in korte tijd
          binnenkregen.
          <br />
          De kosten zijn laag en de uitstraling professioneel.
          <br />
          Een echte aanrader.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Stichting Philadelphia Zorg</h2>
        <p>
          Via deBanenSite.nl is de vacature voor de functie van coördinerend
          begeleider naar tevredenheid verlopen. Diverse reflectanten met de
          juiste kandidaat er tussen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>De Jong Petrol Service BV</h2>
        <p>
          Middels deBanenSite.nl hebben we een vacature geplaatst voor onze
          zoektocht naar Service medewerkers voor onze 5 Shell Tankstations te
          Arnhem en directe omgeving.
          <br />
          We hebben aansluitende reacties mogen ontvangen en er zijn recent 3
          kandidaten aangenomen. deBanenSite.nl heeft ons geen kwantiteit
          geleverd maar kwaliteit en dat is waar we erg content mee zijn.
          <br />
          Voor een volgende openstaande vacature zullen we ons direct wenden tot
          deze partij.
        </p>
        <p>
          &nbsp;
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>VOC Onderhoud</h2>
        <p>
          De geplaatste vacatures van VOC zijn vrij snel ingevuld door adequate
          kandidaten. Het is belangrijk dat de selectiecriteria helder zijn
          anders wordt het bijna onmogelijk door het aantal reacties heen te
          komen. Werving via internet / sociale media wordt door ons
          aanbevolen.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Van Enckevort</h2>
        <p>
          Wij hebben 2 verschillende vacatures geplaatst opdeBanenSite.nl.
          <br />
          Er werd direct en vakkundig geschakeld door de medewerkers van
          deBanenSite.nl.
          <br />
          Onze bevindingen zijn erg positief, we hebben heel veel serieuze
          reacties en 2 nieuwe collega’s gekregen
          <br />
          De volgende keer zullen we hen zeker weer inschakelen.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
          &nbsp;-&nbsp;
        </p>
        <h2>Multiwal B.V.</h2>
        <p>
          Bij deze willen wij doorgeven dat de vacature afgelopen vrijdag is
          vervuld, middels een sollicitatie via deBanenSite.nl.
          <br />
          Hartelijk dank en tot de volgende keer.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>'t Sfeerhuys "de Looimolen"</h2>
        <p>
          't Sfeerhuys de Looimolen te Nijmegen was op zoek naar een chef- kok.
          <br />
          Ik was zeer verrast dat via deBanenSite.nl zo snel reacties zijn
          gekomen op de vacature voor een chef kok. In korte tijd hadden we
          genoeg sollicitanten om binnen 3 weken de juiste persoon binnen te
          halen. De kosten die wij kwijt waren voor de plaatsing van de vacature
          zijn in ons geval de moeite waard geweest.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>TB-Transportbandenservice BV</h2>
        <p>
          Via deBanenSite.nl is het ons gelukt binnen no time een gemotiveerde
          en geschikte kandidaat te vinden! Voor de toekomst weten we jullie wel
          te vinden!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Aannemingsbedrijf van der Zanden Moergestel BV</h2>
        <p>
          Na plaatsing van onze vacature op ‘deBanenSite.nl' volgde al snel
          diverse sollicitaties.
          <br />
          Na een voorselectie hebben we een aantal kandidaten uitgenodigd voor
          een gesprek.
          <br />
          Hieruit is een sollicitant gekomen die perfect aan ons profiel
          voldeed.
          <br />
          Kortom, een snelle en voordelige manier om een vacature in te vullen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Medisch Centrum Kraaiennest</h2>
        <p>
          Ik ben heel tevreden over het aantal reacties dat is binnen gekomen
          via deBanenSite.nl
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Gasterij 't Woud</h2>
        <p>
          Veel reacties gehad op onze vacature bij deBanenSite.nl.
          <br />
          Ook voor de horeca!
          <br />
          Veel enthousiaste en gemotiveerde toekomstige werknemers voor uw
          onderneming.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Farm Dairy</h2>
        <p>
          Via deBanenSite.nl hebben we goede sollicitaties ontvangen voor de
          functie van Procesoperator.
          <br />
          We hebben voor het eerst een vacature op deBanenSite.nl geplaatst en
          dat is goed bevallen.
          <br />
          Bij de volgende vacature zullen we zeker opnieuw van deBanenSite
          gebruik maken.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Interstream Barging</h2>
        <p>
          Dankzij deBanenSite.nl is het gelukt om onze vacature binnen 3 weken
          in te vullen. Dankzij het snelle schakelen van de medewerkers en de
          goede samenwerking stond onze vacature binnen no-time online. Dit was
          de eerste keer dat we via de banensite een vacature geplaatst hebben
          en inmiddels staat er weer een nieuwe vacature uit via deBanenSite.nl.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Alltech</h2>
        <p>
          Via deBanenSite.nl hebben we goede sollicitaties ontvangen en de
          juiste collega gevonden voor onze vacature van Marketing Coordinator.
          <br />
          We hebben voor het eerst op deze manier een vacature uitgezet.
          deBanenSite.nl is een goede manier om een vacature te vullen.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Texaco Nederland</h2>
        <p>
          Het aantal reacties op de eerste drie vacatures die we hebben uitgezet
          is prima, dus wij zijn erg enthousiast.
          <br />
          Bedankt voor de toelichting, destijds,&nbsp; jullie hebben helemaal
          gelijk gehad. Jullie kunnen Texaco Nederland tot een van jullie nieuwe
          klanten rekenen.&nbsp;
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Reedijk Wonen</h2>
        <p>
          Wij hebben 3 verschillende vacatures geplaatst op deBanenSite.nl. Onze
          bevindingen zijn erg positief, we hebben heel veel serieuze reacties
          gekregen.
          <br />
          De samenwerking met de mensen van deBanenSite.nl is ook zeer goed te
          noemen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Topflowers BV</h2>
        <p>
          Via deBanenSite.nl hebben wij snel een goede collega gevonden voor
          onze vacature.
          <br />
          deBanenSite.nl is een goede manier om een geschikte baan te vinden.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Makelaarsland</h2>
        <p>
          Makelaarsland maakt bij voorkeur gebruik van internet voor het werven
          van personeel.
          <br />
          Onze ervaring met andere banensites is dat deze vaak overspoeld zijn
          met publicaties van werving en selectie bureaus.
          <br />
          Daarbij vielen de reacties vaak tegen. Daarom zijn wij laatst op een
          introductie aanbieding ingegaan van deBanenSite.nl.
          <br />
          Door de snelle persoonlijke afhandeling stonden de vacatures dezelfde
          dag al online.
          <br />
          De vacature staat 2 maanden uit, maar ruim voor die termijn verstreken
          was, hadden wij al meer dan voldoende goede reacties ontvangen.
          <br />
          Wat mij betreft is dit zeker voor herhaling vatbaar.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Transport Onderneming van Santen B.V.</h2>
        <p>
          Transport Onderneming van Santen B.V. was opzoek naar een chauffeur
          die ons team moest versterken.&nbsp;Wij werden benaderd door
          deBanenSite.nl en na een goed gesprek en uitleg hoe het werkte stond
          er dezelfde dag een vacature op de site. Via deze site stroomde de
          sollicitaties binnen en met succes, de chauffeur die we zochten rijdt
          reeds bij ons. deBanenSite.nl werkt snel en alles is goed geregeld.
          Wij zijn zeer tevreden over deze site, een aanrader!
        </p>
        <h2>Gastouderbureau Kinderoase B.V.</h2>
        <p>
          Adverteren via deBanenSite.nl werkt! Vandaag (24-1) een vacature
          voortijdig laten verwijderen, omdat de juiste kandidaat al is
          aangesteld. Het voelt als een luxe om zoveel goede reacties te
          ontvangen voor een redelijk scherp tarief. Daarbij biedt de banensite
          een goede persoonlijke afhandeling, slechts 1 telefoontje en alles
          wordt voor je geregeld.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Vechtdal College Hardenberg</h2>
        <p>
          Wij, het Vechtdal College Hardenberg, hebben voor&nbsp;de vacatures
          Engels, Nederlands en Beeldende Vorming o.a. geworven via
          deBanenSite.nl . Inmiddels zijn deze vacatures naar alle tevredenheid
          ingevuld, mede door het plaatsen van de vacatures op deBanenSite.nl!
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Facédo Geveltechniek</h2>
        <p>
          Facédo is uw innovatieve partner op het gebied van geveltechniek en
          biedt een volledig pakket producten (kunststof, aluminium en staal) en
          een compleet scala aan diensten onder één dak. Facédo is niet
          verbonden aan enig gevelsysteem en heeft geen verplichtingen aan enig
          (toe)leverancier. Hierdoor kunnen wij u volledig onafhankelijk
          adviseren en producten leveren die geheel zijn afgestemd op uw wensen.
          <br />
          De kern van Facédo bestaat uit een enthousiast team dat zijn sporen
          inmiddels heeft verdiend in de gevelbouw. Wij helpen u om een
          gezichtsbepalend gevelbouwwerk te ontwikkelen en te bouwen dat geheel
          is toegesneden op uw wensen. Het woord gezichtsbepalend gebruiken wij
          hier niet toevallig. Facédo is een afgeleide van het Latijns facies:
          het gezicht van een gebouw. Dat gezicht is het visitekaartje van ieder
          zichzelf respecterend bedrijf. En daarbij horen vanzelfsprekend de
          hoogste kwaliteitseisen. Facédo is in staat om hoogwaardige
          gevelelementen te leveren, die voldoen aan alle eisen die u ons stelt.
        </p>
        <p>
          Met succes hebben wij via deBanenSite.nl&nbsp;onze nieuwe collega
          mogen verwelkomen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>AquaPurga International B.V.</h2>
        <p>
          We hebben in December 2011 met succes gebruik gemaakt van
          deBanenSite.nl voor loodgieters/monteurs en boekhouder.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Zorgwaard te Puttershoek</h2>
        <p>
          Zorgwaard is een middelgrote zorgverlener in de Hoeksche Waard op het
          gebied van thuiszorg, verpleeghuis- en verzorgingshuiszorg.
          <br />
          Op de vacatures die op deBanenSite.nl gepubliceerd zijn kwamen
          voldoende en kwalitatief goede reacties binnen. De dienstverlening van
          de medewerkers was snel en soepel.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Mid Ocean Brands te Barneveld</h2>
        <p>
          Mid Ocean Brands is één van de grootste importeurs en leveranciers van
          relatiegeschenken en premiums. Deze promotionele artikelen en
          relatiegeschenken worden bedrukt in onze drukkerij in Barneveld.
          <br />
          Hier ontstonden vacatures voor medewerkers drukkerij en een medewerker
          voor de voorbereiding van de drukkerij. Wij werden getipt onze
          vacatures te plaatsen op deBanenSite.nl, en met succes! Via de
          prettige samenwerking stond de vacature snel online en hebben we
          ontzettend veel reacties gekregen met over het algemeen goede
          kandidaten. Wij zullen voor functies op dit niveau in de toekomst
          zeker weer gebruik maken van deBanenSite.nl.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Delftstede</h2>
        <p>
          Delftstede was op zoek naar een directeur. Naar aanleiding van de
          plaatsing van de advertentie in de krant werden wij benaderd door
          deBanenSite.nl. De plaatsing was snel geregeld en we hebben vrij veel
          reakties via deBanenSite.nl ontvangen. Helaas zat de juiste kandidaat
          hier niet bij maar wij waren zeker niet ontevreden over het resultaat.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Kasteel Congreshotel te Oud Poelgeest</h2>
        <p>
          Kasteel Congreshotel Oud Poelgeest is een kleinschalige congres (tot
          100 personen); vergader en trainingslocatie op een prachtig landgoed.
          Wij werken al jaren op een hoog niveau en selecteren daar onze
          werknemers op.
          <br />
          Voor onze Horeca personeelsadvertentie maken wij al enige jaren
          gebruik van deBanenSite.nl. Dit tot volle tevredenheid. We merken dat
          de vacaturesite goed geraadpleegd wordt en ontvangen altijd veel en
          over het algemeen kwalitatief goede c.v.'s van kandidaten. De
          medewerkers van deBanenSite.nl zijn altijd snel, accuraat en graag
          bereid tot meedenken. We wensen ze dan ook veel succes toe.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>EMRI</h2>
        <p>
          EMRI in Ede is gespecialiseerd in de reparatie, service en onderhoud
          van alle soorten en merken generatoren en elektromotoren. <br />
          Door de combinatie van elektrotechniek en elektromechanica is het in
          deze vakrichting altijd lastig om voldoende gekwalificeerd personeel
          te vinden. <br />
          Dankzij deBanenSite.nl hebben wij invulling kunnen geven aan onze
          vacature voor allround monteur. <br />
          Wij zijn daarnaast ook goed te spreken over de directe handelswijze
          van deBanensite.nl rondom voorbereiding, plaatsing en afhandeling van
          vacatures.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Bouw- en Aannemingsbedrijf Stekelenburg B.V.</h2>
        <p>
          Bouw- en Aannemingsbedrijf Stekelenburg B.V. is een bedrijf die
          werkzaam is in de betonbouw en kelderbouw.
          <br />
          Wij hadden een vacature voor de functie van
          calculator/werkvoorbereider.
          <br />
          Voor deze vacature hebben wij contact opgenomen met de banensite.
          <br />
          Dezelfde dag nog was alles geregeld en stond onze vacature al op de
          site.
          <br />
          Via deze site hebben wij diverse sollicitaties gekregen waarbij ook de
          geschikte kandidaat zat.
          <br />
          Kortom deBanenSite.nl regelt uw vacature snel en goed, en voor de
          kosten hoeft u het zeker niet te laten.
          <br />
          Hebben wij weer een vacature dan kloppen we zeker weer bij de
          banensite aan.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>IHB Integrated Healthservices te Baambrugge</h2>
        <p>
          Na aanleiding van de goede service van deBanenSite.nl en vervulling
          van een voorgaande vacature hebben wij momenteel een nieuwe
          advertentie geplaatst.
          <br />
          We zijn positief gestemd dat middels een advertentie op deBanenSite.nl
          ook deze vacature door hen wordt ingevuld.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Roordink Bedrijfswagens B.V.</h2>
        <p>
          Onze eerste ervaringen met deBanenSite.nl zijn positief.
          <br />
          Met succes hebben wij via deBanenSite.nl een nieuwe collega kunnen
          verwelkomen.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
        <h2>Bens Reclame en Marketing te Leeuwarden</h2>
        <p>
          De zoektocht naar goed personeel is en blijft de basis van de
          kwaliteit van je onderneming.
          <br />
          Door de gerichte aanpak van deBanenSite.nl hebben wij kwalitatief
          goede reacties ontvangen voor de vacatures binnen onze organisatie.
          <br />
          Met name de regionale aanpak, waarmee we hebben kunnen voorkomen dat
          we reacties vanuit het hele land kregen, was de juiste aanpak.
          <br />
          Bij de volgende zoektocht zullen we opnieuw van deze site gebruik
          maken.
        </p>
        <p>
          <Link href="/vacature-plaatsen">Vacature plaatsen</Link>
        </p>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default ReferencesPage;
